import { StrictMode } from "react"

import {
  EventType,
  PublicClientApplication,
  type AccountInfo,
  type AuthenticationResult,
  type EventMessage,
} from "@azure/msal-browser"
import { createRoot } from "react-dom/client"

import App from "./App.tsx"
import { msalConfig } from "./authConfig.ts"
import "./index.css"

export const msalInstance = new PublicClientApplication(msalConfig)

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0])
}

// Listen for sign-in event and set active account
msalInstance.addEventCallback((event: EventMessage) => {
  const payload = event.payload as AuthenticationResult
  if (event.eventType === EventType.LOGIN_SUCCESS && payload.account) {
    const account: AccountInfo = payload.account
    msalInstance.setActiveAccount(account)
    window.history.pushState(null, "", payload.state)
  }
})

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App instance={msalInstance} />
  </StrictMode>,
)
